import * as api from './reminder-settings-api';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';
import * as actions from '../account-settings/actions/creators';
import { initialState } from '../account-settings/account-settings-reducer';

export const getReminderSettings = () => (dispatch) => (
  api.getReminderSettings()
    .then(
      (response) => dispatch(actions.loadReminderSettings(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    )
);

const createInitialPatientReminderSettings = (initialPatientReminderSettings, systemReminderSettings) =>
  ({ ...initialPatientReminderSettings,
    appointmentReminderOffset: systemReminderSettings.patientDefaultAppointmentReminderOffset,
    followUpReminderOffset: systemReminderSettings.patientDefaultFollowUpReminderOffset,
    usePrimaryEmail: true });

export const getPatientReminderSettings = (patientId) => (dispatch, getState) => {
  const reminderSettings = getState().accountSettings.reminderSettings.reminderSettings;

  return api.getPatientReminderSettings(patientId)
    .then(
      (response) => dispatch(actions.loadPatientReminderSettings(response.data)),
      (axiosResponse) => {
        if (axiosResponse.response.status === 404) {
          dispatch(actions.loadPatientReminderSettings(
            createInitialPatientReminderSettings(
              initialState.patientReminderSettings,
              reminderSettings)));
        } else {
          dispatch(MsgBarActions.showErrorMessage());
        }
      }
    );
};


export const setPatientReminderSettings = (patientId, patientReminderSettings) => (dispatch) => (
  api.putPatientReminderSettings(patientId, patientReminderSettings)
    .then(
      (response) => {
        dispatch(actions.loadPatientReminderSettings(response.data));
        dispatch(MsgBarActions.showSuccessMessage('patientReminderSettingsSaveSuccess'));
      },
      () => dispatch(MsgBarActions.showErrorMessage())
    )
);
